export const GOOGLE_MAP_SCRIPT_BASE_URL =
  "https://maps.googleapis.com/maps/api/js";
